import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UploadDocumentsService {
  mandatoryEducationDetails:any;

  constructor(public http:HttpClient) { }

  getDocsData(applicationId: number): Observable<any>{
    return this.http.get(environment.BASE_URL_PCD + 'api/das/' + applicationId)
  }

  // OLD
  // public deleteDocument(payload): Observable<any>{
  //   return this.http.post(environment.BASE_URL_COMMON+'attachment/deleteByDocumentId',payload)
  // }

  public deleteDocument(payload): Observable<any>{
    return this.http.post(
      environment.BASE_URL_PCD + 'api/das/app/docs/delete',
      this.toFormData(payload)
    )
  }

  // OLD
  // public getAttachmentByDocumentId(payload){
  //   return this.http.post(environment.BASE_URL_COMMON+'attachment/getAttachmentByDocumentId',payload)
  // }

  // NEW
  public getAttachmentByDocumentId(payload){
    return this.http.post(
      environment.BASE_URL_PCD + 'api/das/app/docs/download',
      this.toFormData(payload)
    )
  }

  /** Legacy common REST (JSON POST) — view/download for read-only DAS before createDate cutoff. */
  public getAttachmentByDocumentIdLegacyCommonRest(payload: { data: { documentId: string; acronym: string } }): Observable<any> {
    return this.http.post(
      environment.BASE_URL_COMMON + 'attachment/getAttachmentByDocumentId',
      payload
    );
  }

  // OLD
  // public uploadDocument(payload): Observable<any>{
  //   return this.http.post(environment.BASE_URL_COMMON+'attachment/uploadDocument',payload)
  // }

  // NEW
  public uploadDocument(payload): Observable<any>{
    return this.http.post(
      environment.BASE_URL_PCD + 'api/das/app/docs/upload',
      this.toFormData(payload)
    )
  }

  // OLD
  // public getDocumentList(payload): Observable<any>{
  //   return this.http.post(environment.BASE_URL_COMMON+'attachment/getDocumentByAppIdAndAcronym',payload)
  // }

  // NEW
  public getDocumentList(payload): Observable<any>{
    return this.http.post(
      environment.BASE_URL_PCD + 'api/das/app/docs/all-files',
      this.toFormData(payload)
    )
  }

  /** Legacy common REST (JSON POST) — read-only DAS apps before `createDate` cutoff (see upload-documents). */
  public getDocumentListLegacyCommonRest(payload: { data: { applicationId: number; processAcronym: string } }): Observable<any> {
    return this.http.post(
      environment.BASE_URL_COMMON + 'attachment/getDocumentByAppIdAndAcronym',
      payload
    );
  }

  private toFormData(payload: any): FormData {
    if (payload instanceof FormData) {
      return payload;
    }

    const formData = new FormData();
    const source = payload && payload.data ? payload.data : (payload || {});

    Object.keys(source).forEach((key) => {
      const value = source[key];
      if (value === undefined || value === null) {
        return;
      }
      if (value instanceof File) {
        formData.append(key, value, value.name);
      } else if (value instanceof Blob) {
        formData.append(key, value);
      } else {
        formData.append(key, String(value));
      }
    });

    // Backward compatibility for existing callers that still pass `acronym`.
    if (source && source.acronym && !source.processAcronym) {
      formData.append('processAcronym', String(source.acronym));
    }

    return formData;
  }

  public saveApplicationData(payload):Observable<any>{
    return this.http.post(environment.BASE_URL_DAS+'das/saveApplicationData',payload)
  }

  public setMandatoryEducation(value){
    this.mandatoryEducationDetails = value
  }
  public getMandatoryEducation(){
    return this.mandatoryEducationDetails
  }
}
